// extracted by mini-css-extract-plugin
var _1 = "U9c9rnB9Pw";
var _2 = "BDw8IIR99z";
var _3 = "z9EjID9EQx";
var _4 = "gqgfpq4Zol";
export { _1 as "caption", _2 as "description", _3 as "legend", _4 as "root" }
